import React, { useEffect, useRef, useState } from 'react'
import './Myprofile.css';
import { FaUser, FaLock, FaImages, FaSignOutAlt, FaEdit, FaCalendar, FaInstagram, FaEye, FaEyeSlash } from 'react-icons/fa';
import { SiLinkedin } from 'react-icons/si';
import Subscribe from '../components/Subscribe';
import Footer from '../components/Footer';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { api } from '../services/api';

const Myprofile = () => {
  const { logout, user, getProfile } = useAuth();
  const navigate = useNavigate();
  const avatarInputRef = useRef(null);
  const dobPickerRef = useRef(null);
  const [activeTab, setActiveTab] = useState('personal');
  const [isEditingPersonal, setIsEditingPersonal] = useState(false);
  const [isEditingPhotos, setIsEditingPhotos] = useState(false);
  const [profileData, setProfileData] = useState({
    gender: 'male',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    dob: '',
    address1: '',
    address2: '',
    postalCode: '',
    city: '',
    state: '',
    country: '',
    designation: '',
    company: '',
    instagram: '',
    linkedin: '',
    aboutMe: '',
    profilePicture: ''
  });
  const [uploadedPhotos, setUploadedPhotos] = useState([null, null, null]);
  const [photoFiles, setPhotoFiles] = useState([null, null, null]);
  const [profilePictureIndex, setProfilePictureIndex] = useState(0);
  const [passwordData, setPasswordData] = useState({ password: '', confirmPassword: '' });
  const [isSavingPersonal, setIsSavingPersonal] = useState(false);
  const [isSavingPhotos, setIsSavingPhotos] = useState(false);
  const [isSavingPassword, setIsSavingPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [personalMessage, setPersonalMessage] = useState('');
  const [personalError, setPersonalError] = useState('');
  const [photoMessage, setPhotoMessage] = useState('');
  const [photoError, setPhotoError] = useState('');
  const [passwordMessage, setPasswordMessage] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [successPopup, setSuccessPopup] = useState({ open: false, message: '', isError: false });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const professions = [
    'Technology & IT',
    'Creative Arts & Design',
    'Media & Entertainment',
    'Sports & Fitness',
    'Hospitality & Tourism',
    'Retail & E-commerce',
    'Manufacturing & Engineering',
    'Education',
    'Legal & Consultancy',
    'Science & Research',
    'Transportaion & Logistics',
    'Entrepreneurship',
    'Marketing & Advertising',
    'Environmental & Sustainaibility',
    'Pharmaceuticals & Biotechnology'
  ];

  const formatDobForInput = (value) => {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const formatDobForApi = (value) => {
    if (!value) return undefined;
    const trimmed = value.trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
      return trimmed;
    }
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(trimmed)) {
      const [day, month, year] = trimmed.split('/');
      return `${year}-${month}-${day}`;
    }
    return trimmed;
  };

  const addIfPresent = (payload, key, value) => {
    if (value === undefined || value === null) return;
    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (!trimmed) return;
      payload[key] = trimmed;
      return;
    }
    payload[key] = value;
  };

  useEffect(() => {
    if (!user) {
      getProfile().catch(() => {});
      return;
    }

    setProfileData((prev) => ({
      ...prev,
      gender: user.gender || prev.gender,
      firstName: user.firstName || '',
      lastName: user.lastName || '',
      email: user.email || '',
      phone: user.phone || '',
      dob: formatDobForInput(user.dob),
      city: user.city || '',
      state: user.state || '',
      country: user.country || '',
      designation: user.profession || '',
      instagram: user.instagram || '',
      linkedin: user.linkedin || '',
      aboutMe: user.bio || '',
      profilePicture: user.profilePicture || ''
    }));

    const images = Array.isArray(user.images) ? user.images.slice(0, 3) : [];
    const nextPhotos = [images[0] || null, images[1] || null, images[2] || null];
    setUploadedPhotos(nextPhotos);
    setPhotoFiles([null, null, null]);

    if (user.profilePicture) {
      const picIndex = nextPhotos.findIndex((photo) => photo === user.profilePicture);
      setProfilePictureIndex(picIndex >= 0 ? picIndex : 0);
    }
  }, [user, getProfile]);

  const handleInputChange = (e) => {
    setProfileData({ ...profileData, [e.target.name]: e.target.value });
  };

  const handleDobPickerChange = (event) => {
    const value = event.target.value;
    if (!value) {
      setProfileData({ ...profileData, dob: '' });
      return;
    }
    const [year, month, day] = value.split('-');
    const formatted = `${day}/${month}/${year}`;
    setProfileData({ ...profileData, dob: formatted });
  };

  const handlePhotoUpload = (index, event) => {
    const file = event.target.files?.[0];
    if (file) {
      setPhotoFiles((prev) => {
        const nextFiles = [...prev];
        nextFiles[index] = file;
        return nextFiles;
      });
      const reader = new FileReader();
      reader.onloadend = () => {
        setUploadedPhotos((prev) => {
          const newPhotos = [...prev];
          newPhotos[index] = reader.result;
          return newPhotos;
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const isRemoteImage = (value) => typeof value === 'string' && value && !value.startsWith('data:');

  const handleDeletePhoto = async (index, event) => {
    event?.preventDefault();
    event?.stopPropagation();
    if (!isEditingPhotos) return;
    const targetPhoto = uploadedPhotos[index];
    if (!targetPhoto) return;

    setPhotoError('');
    setPhotoMessage('');
    setSuccessPopup({ open: false, message: '', isError: false });

    const nextPhotos = [...uploadedPhotos];
    nextPhotos[index] = null;
    const nextFiles = [...photoFiles];
    nextFiles[index] = null;

    const updateLocalState = () => {
      setUploadedPhotos(nextPhotos);
      setPhotoFiles(nextFiles);
      if (profilePictureIndex === index) {
        const nextIndex = nextPhotos.findIndex(Boolean);
        setProfilePictureIndex(nextIndex >= 0 ? nextIndex : 0);
      }
    };

    if (!isRemoteImage(targetPhoto)) {
      updateLocalState();
      return;
    }

    setIsSavingPhotos(true);
    try {
      await api.deleteImageByUrl(targetPhoto);

      const remainingImages = nextPhotos.filter(Boolean).slice(0, 3);
      const isProfilePictureFromPhotos = uploadedPhotos.some(
        (photo) => photo && photo === profileData.profilePicture
      );
      const deletingProfilePicture = isProfilePictureFromPhotos && profilePictureIndex === index;
      const nextProfilePicture = deletingProfilePicture
        ? (remainingImages[0] || '')
        : profileData.profilePicture;
      const payload = { images: remainingImages };

      if (deletingProfilePicture) {
        payload.profilePicture = nextProfilePicture;
      }

      await api.updateProfile(payload);
      updateLocalState();
      if (deletingProfilePicture) {
        setProfileData((prev) => ({ ...prev, profilePicture: nextProfilePicture }));
      }
      await getProfile().catch(() => {});
      setSuccessPopup({ open: true, message: 'Photo deleted successfully.', isError: false });
    } catch (error) {
      setSuccessPopup({ open: true, message: error.message || 'Unable to delete photo.', isError: true });
    } finally {
      setIsSavingPhotos(false);
    }
  };

  const handleAvatarUpload = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    setPhotoError('');
    setPhotoMessage('');
    setSuccessPopup({ open: false, message: '', isError: false });
    try {
      const uploadResponse = await api.uploadProfilePicture(file);
      const profilePicture = uploadResponse?.profilePicture;
      if (profilePicture) {
        await api.updateProfile({ profilePicture });
        setProfileData((prev) => ({ ...prev, profilePicture }));
        await getProfile().catch(() => {});
        setSuccessPopup({ open: true, message: 'Profile picture updated.', isError: false });
      }
    } catch (error) {
      setSuccessPopup({ open: true, message: error.message || 'Unable to upload profile picture.', isError: true });
    } finally {
      if (event.target) {
        event.target.value = '';
      }
    }
  };

  const handleSavePersonal = async () => {
    setPersonalError('');
    setPersonalMessage('');
    setSuccessPopup({ open: false, message: '', isError: false });
    setIsSavingPersonal(true);

    try {
      const payload = {};
      addIfPresent(payload, 'firstName', profileData.firstName);
      addIfPresent(payload, 'lastName', profileData.lastName);
      addIfPresent(payload, 'gender', profileData.gender);
      addIfPresent(payload, 'country', profileData.country);
      addIfPresent(payload, 'state', profileData.state);
      addIfPresent(payload, 'city', profileData.city);
      const dobValue = formatDobForApi(profileData.dob);
      if (dobValue) payload.dob = dobValue;

      if (Object.keys(payload).length === 0) {
        setSuccessPopup({ open: true, message: 'No changes to save.', isError: true });
        return;
      }

      await api.updateProfile(payload);
      await getProfile().catch(() => {});
      setIsEditingPersonal(false);
      setSuccessPopup({ open: true, message: 'Profile updated successfully.', isError: false });
    } catch (error) {
      setSuccessPopup({ open: true, message: error.message || 'Unable to update profile.', isError: true });
    } finally {
      setIsSavingPersonal(false);
    }
  };

  const handleSavePhotos = async () => {
    setPhotoError('');
    setPhotoMessage('');
    setSuccessPopup({ open: false, message: '', isError: false });
    setIsSavingPhotos(true);

    try {
      let nextPhotos = [...uploadedPhotos];
      const pendingUploads = photoFiles
        .map((file, index) => (file ? { file, index } : null))
        .filter(Boolean);

      if (pendingUploads.length > 0) {
        const uploadResponse = await api.uploadOnboardingImages(
          pendingUploads.map((item) => item.file)
        );
        const uploadedUrls = uploadResponse?.images || [];
        uploadedUrls.forEach((url, idx) => {
          const targetIndex = pendingUploads[idx]?.index;
          if (targetIndex !== undefined) {
            nextPhotos[targetIndex] = url;
          }
        });
        setPhotoFiles([null, null, null]);
      }

      const imagesPayload = nextPhotos.filter(Boolean).slice(0, 3);
      const payload = {};
      addIfPresent(payload, 'bio', profileData.aboutMe);
      addIfPresent(payload, 'instagram', profileData.instagram);
      addIfPresent(payload, 'linkedin', profileData.linkedin);

      const profession = profileData.designation?.trim();
      if (profession && professions.includes(profession)) {
        payload.profession = profession;
      }

      if (imagesPayload.length > 0) {
        payload.images = imagesPayload;
      }

      const profilePicture =
        nextPhotos[profilePictureIndex] ||
        profileData.profilePicture ||
        imagesPayload[0];

      if (profilePicture) {
        payload.profilePicture = profilePicture;
      }

      if (Object.keys(payload).length === 0) {
        setSuccessPopup({ open: true, message: 'No changes to save.', isError: true });
        return;
      }

      await api.updateProfile(payload);
      setUploadedPhotos(nextPhotos);
      setProfileData((prev) => ({ ...prev, profilePicture: profilePicture || prev.profilePicture }));
      await getProfile().catch(() => {});
      setIsEditingPhotos(false);
      setSuccessPopup({ open: true, message: 'Profile updated successfully.', isError: false });
    } catch (error) {
      setSuccessPopup({ open: true, message: error.message || 'Unable to update photos or social info.', isError: true });
    } finally {
      setIsSavingPhotos(false);
    }
  };

  const handleSavePassword = async () => {
    setPasswordError('');
    setPasswordMessage('');
    setSuccessPopup({ open: false, message: '', isError: false });

    const password = passwordData.password.trim();
    const confirmPassword = passwordData.confirmPassword.trim();

    if (!password || !confirmPassword) {
      setSuccessPopup({ open: true, message: 'Please enter and confirm your new password.', isError: true });
      return;
    }

    if (password !== confirmPassword) {
      setSuccessPopup({ open: true, message: 'Passwords do not match.', isError: true });
      return;
    }

    if (!profileData.email) {
      setSuccessPopup({ open: true, message: 'Email is required to update password.', isError: true });
      return;
    }

    setIsSavingPassword(true);
    try {
      await api.updateProfilePassword({
        email: profileData.email,
        password,
        cnfPassword: confirmPassword
      });
      setPasswordData({ password: '', confirmPassword: '' });
      setSuccessPopup({ open: true, message: 'Password updated successfully.', isError: false });
    } catch (error) {
      setSuccessPopup({ open: true, message: error.message || 'Unable to update password.', isError: true });
    } finally {
      setIsSavingPassword(false);
    }
  };

  const handlePasswordChange = (e) => {
    setPasswordData({ ...passwordData, [e.target.name]: e.target.value });
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const renderPersonalInfo = () => (
    <div className="profile-content-box">
      <div className="profile-header">
        <h2>Personal Information</h2>
        <button
          className="edit-btn"
          type="button"
          onClick={() => setIsEditingPersonal((prev) => !prev)}
        >
          <FaEdit /> {isEditingPersonal ? 'CANCEL' : 'EDIT'}
        </button>
      </div>
      
      <div className="gender-section">
        <label>
          <input
            type="radio"
            name="gender"
            value="male"
            checked={profileData.gender === 'male'}
            onChange={handleInputChange}
            disabled={!isEditingPersonal}
          />
          <span>Male</span>
        </label>
        <label>
          <input
            type="radio"
            name="gender"
            value="female"
            checked={profileData.gender === 'female'}
            onChange={handleInputChange}
            disabled={!isEditingPersonal}
          />
          <span>Female</span>
        </label>
      </div>

      <div className="form-grid">
        <div className="form-group">
          <input
            type="text"
            name="firstName"
            value={profileData.firstName}
            onChange={handleInputChange}
            placeholder="First Name"
            disabled={!isEditingPersonal}
          />
        </div>
        <div className="form-group">
          <input
            type="text"
            name="lastName"
            value={profileData.lastName}
            onChange={handleInputChange}
            placeholder="Last Name"
            disabled={!isEditingPersonal}
          />
        </div>
        <div className="form-group verified">
          <input
            type="email"
            name="email"
            value={profileData.email}
            onChange={handleInputChange}
            placeholder="Email"
            disabled
          />
          <span className="verified-badge">✓ verified</span>
        </div>
        <div className="form-group date-inputt">
          <input
            type="text"
            name="dob"
            value={profileData.dob}
            onChange={handleInputChange}
            placeholder="DD/MM/YYYY"
            disabled={!isEditingPersonal}
          />
          <input
            ref={dobPickerRef}
            type="date"
            className="dob-hidden-picker"
            onChange={handleDobPickerChange}
            max={new Date().toISOString().split('T')[0]}
            disabled={!isEditingPersonal}
            tabIndex={-1}
          />
          <FaCalendar
            className="calendar-icon"
            onClick={() => {
              if (!isEditingPersonal) return;
              const picker = dobPickerRef.current;
              if (picker?.showPicker) {
                picker.showPicker();
              } else {
                picker?.click();
              }
            }}
          />
        </div>
        <div className="form-group verified full-width">
          <input
            type="tel"
            name="phone"
            value={profileData.phone}
            onChange={handleInputChange}
            placeholder="Phone"
            disabled
          />
          <span className="verified-badge">✓ verified</span>
        </div>
        <div className="form-group">
          <input
            type="text"
            name="address1"
            value={profileData.address1}
            onChange={handleInputChange}
            placeholder="Address 1"
            disabled={!isEditingPersonal}
          />
        </div>
        <div className="form-group">
          <input
            type="text"
            name="address2"
            value={profileData.address2}
            onChange={handleInputChange}
            placeholder="Address 2"
            disabled={!isEditingPersonal}
          />
        </div>
        <div className="form-group">
          <input
            type="text"
            name="postalCode"
            value={profileData.postalCode}
            onChange={handleInputChange}
            placeholder="Postal Code"
            disabled={!isEditingPersonal}
          />
        </div>
        <div className="form-group">
          <input
            type="text"
            name="city"
            value={profileData.city}
            onChange={handleInputChange}
            placeholder="City"
            disabled={!isEditingPersonal}
          />
        </div>
        <div className="form-group">
          <input
            type="text"
            name="state"
            value={profileData.state}
            onChange={handleInputChange}
            placeholder="State"
            disabled={!isEditingPersonal}
          />
        </div>
        <div className="form-group">
          <input
            type="text"
            name="country"
            value={profileData.country}
            onChange={handleInputChange}
            placeholder="Country"
            disabled={!isEditingPersonal}
          />
        </div>
      </div>

      <button
        className="save-btn"
        onClick={handleSavePersonal}
        disabled={isSavingPersonal || !isEditingPersonal}
      >
        {isSavingPersonal ? 'Saving...' : 'Save Changes'}
      </button>
      {personalMessage && <p>{personalMessage}</p>}
      {personalError && <p>{personalError}</p>}
    </div>
  );

  const renderLoginPassword = () => (
    <div className="profile-content-box">
      <h2>Login & Password</h2>
      
      <div className="password-section">
        <div className="lock-icon-wrapper">
          <FaLock className="lock-icon" />
        </div>
        
        <div className="password-inputs">
          <div className="password-input-group">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Enter New Password"
              value={passwordData.password}
              onChange={handlePasswordChange}
            />
            <button
              className="password-toggle-btn"
              type="button"
              onClick={() => setShowPassword((prev) => !prev)}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
          <div className="password-input-group">
            <input
              type={showConfirmPassword ? "text" : "password"}
              name="confirmPassword"
              placeholder="Re-Enter New Password"
              value={passwordData.confirmPassword}
              onChange={handlePasswordChange}
            />
            <button
              className="password-toggle-btn"
              type="button"
              onClick={() => setShowConfirmPassword((prev) => !prev)}
              aria-label={showConfirmPassword ? "Hide confirm password" : "Show confirm password"}
            >
              {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
        </div>
      </div>

      <button className="save-btn" onClick={handleSavePassword} disabled={isSavingPassword}>
        {isSavingPassword ? 'Saving...' : 'Save Changes'}
      </button>
      {passwordMessage && <p>{passwordMessage}</p>}
      {passwordError && <p>{passwordError}</p>}
    </div>
  );

  const renderPhotosSocial = () => (
    <div className="profile-content-box">
      <div className="profile-header">
        <h2>My Photos & Social Info</h2>
        <button
          className="edit-btn"
          type="button"
          onClick={() => setIsEditingPhotos((prev) => !prev)}
        >
          <FaEdit /> {isEditingPhotos ? 'CANCEL' : 'EDIT'}
        </button>
      </div>
      <div className='upload-inst' 
      // style={{ display: 'grid', gridTemplateColumns: '1.1fr 0.9fr', gap: '28px', alignItems: 'start' }}
      >
        <div>
          <p className="upload-instruction">Please upload at least 3 photos</p>
          <div className="photos-grid"
          //  style={{ gridTemplateColumns: 'repeat(3, minmax(0, 1fr))' }}
          >
            <div className="photo-upload-boxx">
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handlePhotoUpload(0, e)}
                style={{ display: 'none' }}
                id="photo-upload-0"
                disabled={!isEditingPhotos}
              />
              <label htmlFor="photo-upload-0" style={{ cursor: 'pointer' }}>
                {uploadedPhotos[0] ? (
                  <div className="photo-preview">
                    <img src={uploadedPhotos[0]} alt="Upload 1" />
                    {isEditingPhotos && (
                      <button
                        className="photo-delete-btn"
                        type="button"
                        onClick={(event) => handleDeletePhoto(0, event)}
                        disabled={isSavingPhotos}
                      >
                        Delete
                      </button>
                    )}
                  </div>
                ) : (
                  <div className="photo-placeholder">
                    <span className="plus-icon">+</span>
                  </div>
                )}
              </label>
              <label className="photo-check-box">
                <input
                  type="radio"
                  name="profilePic"
                  value="0"
                  checked={profilePictureIndex === 0}
                  onChange={() => setProfilePictureIndex(0)}
                  disabled={!isEditingPhotos}
                />
                <span>Make Profile Picture</span>
              </label>
            </div>
            <div className="photo-upload-boxx">
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handlePhotoUpload(1, e)}
                style={{ display: 'none' }}
                id="photo-upload-1"
                disabled={!isEditingPhotos}
              />
              <label htmlFor="photo-upload-1" style={{ cursor: 'pointer' }}>
                {uploadedPhotos[1] ? (
                  <div className="photo-preview">
                    <img src={uploadedPhotos[1]} alt="Upload 2" />
                    {isEditingPhotos && (
                      <button
                        className="photo-delete-btn"
                        type="button"
                        onClick={(event) => handleDeletePhoto(1, event)}
                        disabled={isSavingPhotos}
                      >
                        Delete
                      </button>
                    )}
                  </div>
                ) : (
                  <div className="photo-placeholder">
                    <span className="plus-icon">+</span>
                  </div>
                )}
              </label>
              <label className="photo-check-box">
                <input
                  type="radio"
                  name="profilePic"
                  value="1"
                  checked={profilePictureIndex === 1}
                  onChange={() => setProfilePictureIndex(1)}
                  disabled={!isEditingPhotos}
                />
                <span>Make Profile Picture</span>
              </label>
            </div>
            <div className="photo-upload-boxx">
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handlePhotoUpload(2, e)}
                style={{ display: 'none' }}
                id="photo-upload-2"
                disabled={!isEditingPhotos}
              />
              <label htmlFor="photo-upload-2" style={{ cursor: 'pointer' }}>
                {uploadedPhotos[2] ? (
                  <div className="photo-preview">
                    <img src={uploadedPhotos[2]} alt="Upload 3" />
                    {isEditingPhotos && (
                      <button
                        className="photo-delete-btn"
                        type="button"
                        onClick={(event) => handleDeletePhoto(2, event)}
                        disabled={isSavingPhotos}
                      >
                        Delete
                      </button>
                    )}
                  </div>
                ) : (
                  <div className="photo-placeholder">
                    <span className="plus-icon">+</span>
                  </div>
                )}
              </label>
              <label className="photo-check-box">
                <input
                  type="radio"
                  name="profilePic"
                  value="2"
                  checked={profilePictureIndex === 2}
                  onChange={() => setProfilePictureIndex(2)}
                  disabled={!isEditingPhotos}
                />
                <span>Make Profile Picture</span>
              </label>
            </div>
          </div>

          <div className="social-inputs" style={{ marginTop: '18px' }}>
            <input
              type="text"
              name="designation"
              value={profileData.designation}
              onChange={handleInputChange}
              placeholder="Designation"
              disabled={!isEditingPhotos}
            />
            <input
              type="text"
              name="company"
              value={profileData.company}
              onChange={handleInputChange}
              placeholder="Company Name"
              disabled={!isEditingPhotos}
            />
            <div className="social-input-group">
              <input
                type="text"
                name="instagram"
                value={profileData.instagram}
                onChange={handleInputChange}
                placeholder="Instagram Handle"
                disabled={!isEditingPhotos}
              />
              <FaInstagram className="social-iconn instagram" />
            </div>
            <div className="social-input-group">
              <input
                type="text"
                name="linkedin"
                value={profileData.linkedin}
                onChange={handleInputChange}
                placeholder="LinkedIn URL"
                disabled={!isEditingPhotos}
              />
              <SiLinkedin className="social-iconn linkedin" />
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '18px', height: '100%' }}>
          <div className="about-me-box" style={{ flex: 1 }}>
            <label>About Me</label>
            <textarea
              name="aboutMe"
              value={profileData.aboutMe}
              onChange={handleInputChange}
              placeholder="Atleast 50 Words"
              rows="10"
              disabled={!isEditingPhotos}
            ></textarea>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <button
              className="save-btn"
              onClick={handleSavePhotos}
              disabled={isSavingPhotos || !isEditingPhotos}
            >
              {isSavingPhotos ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </div>
      </div>
      {photoMessage && <p>{photoMessage}</p>}
      {photoError && <p>{photoError}</p>}
    </div>
  );

  return (
    <>
    {successPopup.open && (
      <div className="profile-success-overlay" onClick={() => setSuccessPopup({ open: false, message: '', isError: false })}>
        <div className="profile-success-popup" onClick={(e) => e.stopPropagation()}>
          <h3>{successPopup.isError ? 'Error' : 'Success'}</h3>
          <p>{successPopup.message}</p>
          <button className="save-btn" type="button" onClick={() => setSuccessPopup({ open: false, message: '', isError: false })}>
            OK
          </button>
        </div>
      </div>
    )}
    <div className="myprofile-container">
      <div className="profile-sidebar">
        <div className="profile-avatar">
          <img
            src={profileData.profilePicture || "https://ui-avatars.com/api/?name=User&background=f49778&color=fff&size=150"}
            alt="Profile"
          />
          <input
            type="file"
            accept="image/*"
            ref={avatarInputRef}
            style={{ display: 'none' }}
            onChange={handleAvatarUpload}
          />
          <button
            className="avatar-edit-btn"
            type="button"
            onClick={() => avatarInputRef.current?.click()}
          >
            <FaEdit />
          </button>
        </div>

        <div className="sidebar-menu">
          <button 
            className={`menu-itemm ${activeTab === 'personal' ? 'active' : ''}`}
            onClick={() => setActiveTab('personal')}
          >
            <FaUser /> 
            <h2>Personal Information</h2>
          </button>
          <button 
            className={`menu-itemm ${activeTab === 'password' ? 'active' : ''}`}
            onClick={() => setActiveTab('password')}
          >
            <FaLock /> 
            <h2>Login & Password</h2>
          </button>
          <button 
            className={`menu-itemm ${activeTab === 'photos' ? 'active' : ''}`}
            onClick={() => setActiveTab('photos')}
          >
            <FaImages /> 
            <h2>My Photos & Social Info</h2>
          </button>
          <button className="menu-itemm logout" onClick={handleLogout}>
            <FaSignOutAlt /> 
            <h2>Logout</h2>
          </button>
        </div>
      </div>

      <div className="profile-content">
        {activeTab === 'personal' && renderPersonalInfo()}
        {activeTab === 'password' && renderLoginPassword()}
        {activeTab === 'photos' && renderPhotosSocial()}
      </div>
    </div>
    {/* <Subscribe />
    <Footer /> */}
    </>
  )
}

export default Myprofile
